import { useLayoutEffect, useMemo } from 'react';

interface ResourceLifetime {
  active: boolean;
}

/** Retires async completions when a mounted component changes resources. */
export const useResourceLifetime = (resourceId: string) => {
  const lifetime = useMemo<ResourceLifetime>(() => ({ active: true }), [resourceId]);
  useLayoutEffect(() => {
    lifetime.active = true;
    return () => { lifetime.active = false; };
  }, [lifetime]);
  return {
    isCurrent: () => lifetime.active,
    runIfCurrent: (effect: () => void) => { if (lifetime.active) effect(); },
  };
};
